/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sport/football/match/scoringchance': {
    width: 25,
    height: 25,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M18.906 10.251h-4.302l-1.322-3.949a.45.45 0 00-.851 0l-1.322 3.95H6.807c-.402 0-.633.525-.268.776l3.472 2.439-1.322 3.95c-.147.379.34.73.695.474l3.473-2.417 3.472 2.438c.356.257.843-.095.695-.474l-1.322-3.95 3.473-2.438c.373-.308.116-.799-.27-.799z" _fill="#F6CF33"/>'
  }
})
